import { createFileRoute } from "@tanstack/react-router"
import LtiLaunchPage from "@/routes/-pages/LtiLaunch"

interface LtiLaunchSearchParams {
  launch_context_id?: string
}

export const Route = createFileRoute("/lti/launch")({
  validateSearch: (search: Record<string, unknown>): LtiLaunchSearchParams => ({
    launch_context_id: typeof search.launch_context_id === "string" ? search.launch_context_id : undefined,
  }),
  component: LtiLaunchRoute,
})

function LtiLaunchRoute() {
  const { launch_context_id } = Route.useSearch()

  return <LtiLaunchPage launchContextId={launch_context_id} />
}
